import React from 'react';

import { detectAndroid } from '@zola-helpers/client/dist/es/util/detectBrowser';

import { Container, Title, IosBadgeLink } from './MobileApps.styles';

import appStoreBadge from '../../assets/images/footer/app-store-badge.svg';

type MobileAppsProps = {
  hideTitle?: boolean;
};

const MobileApps = (props: MobileAppsProps): JSX.Element | null => {
  const { hideTitle } = props;
  const isAndroid = typeof window !== 'undefined' && detectAndroid();

  if (isAndroid) {
    return null;
  }

  return (
    <Container>
      {!hideTitle && <Title>Download the Zola App</Title>}
      <IosBadgeLink
        href="https://itunes.apple.com/us/app/zola-wedding-registry-gifts/id852691916"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={appStoreBadge} alt="Download On The App Store" />
      </IosBadgeLink>
    </Container>
  );
};

export default MobileApps;
